module.exports = __webpack_public_path__ + "assets/img/btn-more-f42b2dcf.png";